import { render, staticRenderFns } from "./Questionnaires.vue?vue&type=template&id=67a727a2&scoped=true&"
import script from "./Questionnaires.vue?vue&type=script&lang=js&"
export * from "./Questionnaires.vue?vue&type=script&lang=js&"
import style0 from "./Questionnaires.vue?vue&type=style&index=0&id=67a727a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a727a2",
  null
  
)

export default component.exports